module.exports = __webpack_public_path__ + "media/images/home/concept_scene_2-baa975b6137a7a61a4e463c1dce7e22a.png";